import Vue from 'vue'
import App from './App.vue'
import router from './router'

import ElementUI from 'element-ui'

// config styles
import 'element-ui/lib/theme-chalk/index.css'
import '@/sass/main.scss'

Vue.config.productionTip = false

Vue.use(ElementUI, { size: 'medium' })

const requireAll = requireContext => requireContext.keys().map(requireContext);
const req = require.context('./icons', false, /\.svg$/);
requireAll(req);

Vue.component('svg-icon', require('./components/svg-icon/Index.vue').default);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
